export const SET_ZONES = 'SET_ZONES';
export const SET_SELECTED_ZONE = 'SET_SELECTED_ZONE';
export const SET_ZONES_VISIBILITY = 'SET_ZONES_VISIBILITY';
export const UPDATE_ZONE = 'UPDATE_ZONE';
export const SET_CURRENT_TAB = 'SET_CURRENT_TAB';
export const SET_NEW_ZONE = 'SET_NEW_ZONE';
export const SET_ZONE_DRAW = 'SET_ZONE_DRAW';
export const SET_ZOOM_TO_ELEMENT_ID = 'SET_ZOOM_TO_ELEMENT_ID';
export const UPDATE_RULER = 'UPDATE_RULER';
export const REMOVE_RULER = 'REMOVE_RULER';
export const REMOVE_RULERS = 'REMOVE_RULERS';

export const setSelectedParentStore = (selectedStore) => ({ type: "SET_PARENT_STORE", selectedStore });
  
export const setSelectedSubStore = (selectedStore) => ({ type: "SET_SUB_STORE", selectedStore });

export const setStoresData = (stores) => ({ type: "SET_STORES", stores: stores });

export const setShelves = (shelves) => ({ type: "SET_SHELVES", shelves: shelves });

export const setSelectedPlanogram = (selectedPlanogram) => ({ type: "SET_PLANOGRAM", selectedPlanogram: selectedPlanogram });

export const setProducts = (products) => ({ type: "SET_PRODUCTS", products: products });

export const setIsSceneUpdated = (isSceneUpdated) => ({ type: "SET_IS_SCENE_UPDATED", isSceneUpdated });

export const setUnsavedModifications = (unsavedModifications) => ({ type: "SET_UNSAVED_MODIFICATIONS", unsavedModifications });

export const setRecenterMap = (recenterMap) => ({ type: "SET_RECENTER_MAP", recenterMap });

export const setPreviewVisible = (previewVisible) => ({ type: "SET_PREVIEW_VISIBLE", previewVisible });

export const setSelectedShelfType = (selectedShelfType) => ({ type: "SET_SHELF_TYPE", selectedShelfType });

export const setSelectedProduct = (selectedProduct) => ({ type: "SET_PRODUCT", selectedProduct: selectedProduct });

export const setIsEdit = (isEdit) => ({ type: "SET_IS_EDIT", isEdit });

export const setIsFloorEdit = (isFloorEdit) => ({ type: "SET_IS_FLOOR_EDIT", isFloorEdit });

export const setStoreData = (storeData) => ({ type: "SET_STORE_DATA", storeData });

export const setFloorPlanElements = (elements) => ({ type: "SET_FLOOR_PLAN_ELEMENTS", elements });

export const addFloorPlanElement = (element) => ({ type: "ADD_FLOOR_PLAN_ELEMENT", element });

export const updateFloorPlanElement = (element) => ({ type: "UPDATE_FLOOR_PLAN_ELEMENT", element });

export const removeFloorPlanElement = (element) => ({ type: "REMOVE_FLOOR_PLAN_ELEMENT", element });

export const updateRuler = (ruler) => ({ type: UPDATE_RULER, ruler });

export const removeRuler = (ruler) => ({ type: REMOVE_RULER, ruler });

export const removeRulers = () => ({ type: REMOVE_RULERS });

export const setIsInfoWindowVisible = (isInfoWindowVisible) => ({ type: "SET_IS_INFO_WINDOW_VISIBLE", isInfoWindowVisible });

export const setSelectedStoreElement = (selectedStoreElement) => ({ type: "SET_SELECTED_STORE_ELEMENT", selectedStoreElement });

export const setIsDragEnabled = (isDragEnabled) => ({ type: "SET_IS_DRAG_ENABLED", isDragEnabled });

export const setIsGridEnabled = (isGridEnabled) => ({ type: "SET_IS_GRID_ENABLED", isGridEnabled });

export const setSnapToRuler = (snapToRuler) => ({ type: 'SET_SNAP_TO_RULER', snapToRuler });

export const setMoveElementsWithRuler = (moveElementsWithRuler) => ({ type: 'SET_MOVE_ELEMENTS_WITH_RULER', moveElementsWithRuler });

/*
export const setHistory = (history) => ({
    type: 'SET_HISTORY',
    history
});

export const setHistoryStep = (historyStep) => ({
    type: 'SET_HISTORY_STEP',
    historyStep
});

export const clearHistory = () => ({
    type: 'CLEAR_HISTORY'
});
*/

export const resetStoreData = () => ({ type: 'RESET' });

export const showProjectElements = (showElements) => ({ type: 'SET_SHOW_ELEMENTS', showElements });

export const setIsWallDrawEnabled = (isWallDrawEnabled) => ({ type: 'SET_IS_WALL_DRAW_ENABLED', isWallDrawEnabled });

export const setFloorMapLayerProperties = (floorMapLayerProperties) => ({ type: 'SET_FLOOR_MAP_LAYER_PROPERTIES', floorMapLayerProperties });

export const setStoreUpdated = (storeUpdated) => ({ type: 'SET_STORE_UPDATED', storeUpdated });

export const setZones = (zones) => ({ type: SET_ZONES, zones });

export const setSelectedZone = (zone) => ({ type: SET_SELECTED_ZONE, zone });

export const setZonesVisibility = (zonesVisibility) => ({ type: SET_ZONES_VISIBILITY, zonesVisibility });

export const updateZone = (zone) => ({ type: UPDATE_ZONE, zone });

export const setCurrentTab = (currentTab) => ({ type: SET_CURRENT_TAB, currentTab });

export const setNewZone = (zone) => ({ type: SET_NEW_ZONE, newZone: zone });

export const setZoneDraw = (value) => ({ type: SET_ZONE_DRAW, isZoneDraw: value });

export const setZoomToElementId = (elementId) => ({ type: SET_ZOOM_TO_ELEMENT_ID, elementId });

export const setSideBarIsOpened = (sideBarIsOpened) => ({ type: "SET_SIDEBAR_IS_OPENED", sideBarIsOpened });